import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {
  instructionDescriptionZod,
  instructionIsDraftZod,
  instructionMarkdownZod,
  instructionPathZod,
} from './schemas';

const toolName = 'update-instruction' as const;

const argumentZod = z.object({
  path: instructionPathZod.describe(
    'The instruction file path to update, for example rules/brand.md or brand-guidelines/SKILL.md.'
  ),
  markdown: instructionMarkdownZod.describe(
    'The full markdown content to store at the instruction path.'
  ),
  description: instructionDescriptionZod,
  isDraft: instructionIsDraftZod,
});

export const updateInstructionManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Update instruction',
  llmTool: {
    name: toolName,
    description:
      'Updates one existing agent instruction markdown file in the current site. Overwrites the latest version automatically.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AGENT_INSTRUCTIONS,
  permission: [{resource: 'SiteAgentInstructions', action: 'manage'}],
  confirmBeforeExecuting: true,
});

export type UpdateInstructionArgumentType = z.infer<typeof argumentZod>;
